import { render, staticRenderFns } from "./VoiceBroadcast.vue?vue&type=template&id=941e08e4&scoped=true&"
import script from "./VoiceBroadcast.vue?vue&type=script&lang=js&"
export * from "./VoiceBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./VoiceBroadcast.vue?vue&type=style&index=0&id=941e08e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941e08e4",
  null
  
)

export default component.exports